/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ConversationTranscriptResponseDTO } from '../models';
// @ts-ignore
import type { ConversationTurnDTO } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PageConversationTranscriptListDTO } from '../models';
// @ts-ignore
import type { PageConversationTurnDTO } from '../models';
// @ts-ignore
import type { TranscriptSearchResultDTO } from '../models';
// @ts-ignore
import type { TurnType } from '../models';
/**
 * TranscriptsApi - axios parameter creator
 * @export
 */
export const TranscriptsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a specific transcript with all turns. Requires \'call_log:view\' permission.
         * @summary Get Transcript
         * @param {string} transcriptId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptApiV1TranscriptsTranscriptIdGet: async (transcriptId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transcriptId' is not null or undefined
            assertParamExists('getTranscriptApiV1TranscriptsTranscriptIdGet', 'transcriptId', transcriptId)
            const localVarPath = `/api/v1/transcripts/{transcript_id}`
                .replace(`{${"transcript_id"}}`, encodeURIComponent(String(transcriptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific transcript with all turns. Requires \'call_log:view\' permission.
         * @summary Get Transcript
         * @param {string} transcriptId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptApiV1TranscriptsTranscriptIdGet_1: async (transcriptId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transcriptId' is not null or undefined
            assertParamExists('getTranscriptApiV1TranscriptsTranscriptIdGet_1', 'transcriptId', transcriptId)
            const localVarPath = `/api/v1/transcripts/{transcript_id}`
                .replace(`{${"transcript_id"}}`, encodeURIComponent(String(transcriptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get transcript by call log ID with all turns. Returns 404 if no transcript exists for the call log. Requires \'call_log:view\' permission.
         * @summary Get Transcript By Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet', 'callLogId', callLogId)
            const localVarPath = `/api/v1/transcripts/by-call-log/{call_log_id}`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get transcript by call log ID with all turns. Returns 404 if no transcript exists for the call log. Requires \'call_log:view\' permission.
         * @summary Get Transcript By Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet_2: async (callLogId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet_2', 'callLogId', callLogId)
            const localVarPath = `/api/v1/transcripts/by-call-log/{call_log_id}`
                .replace(`{${"call_log_id"}}`, encodeURIComponent(String(callLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all function calls for a specific transcript. Requires \'call_log:view\' permission.
         * @summary Get Transcript Function Calls
         * @param {string} transcriptId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet: async (transcriptId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transcriptId' is not null or undefined
            assertParamExists('getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet', 'transcriptId', transcriptId)
            const localVarPath = `/api/v1/transcripts/{transcript_id}/function-calls`
                .replace(`{${"transcript_id"}}`, encodeURIComponent(String(transcriptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all function calls for a specific transcript. Requires \'call_log:view\' permission.
         * @summary Get Transcript Function Calls
         * @param {string} transcriptId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet_3: async (transcriptId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transcriptId' is not null or undefined
            assertParamExists('getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet_3', 'transcriptId', transcriptId)
            const localVarPath = `/api/v1/transcripts/{transcript_id}/function-calls`
                .replace(`{${"transcript_id"}}`, encodeURIComponent(String(transcriptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get turns for a specific transcript with optional filtering. Can filter by turn type (user_speech, agent_speech, function_call, event). Requires \'call_log:view\' permission.
         * @summary Get Transcript Turns
         * @param {string} transcriptId 
         * @param {TurnType | null} [turnType] Filter by turn type
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet: async (transcriptId: string, turnType?: TurnType | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transcriptId' is not null or undefined
            assertParamExists('getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet', 'transcriptId', transcriptId)
            const localVarPath = `/api/v1/transcripts/{transcript_id}/turns`
                .replace(`{${"transcript_id"}}`, encodeURIComponent(String(transcriptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (turnType !== undefined) {
                localVarQueryParameter['turn_type'] = turnType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get turns for a specific transcript with optional filtering. Can filter by turn type (user_speech, agent_speech, function_call, event). Requires \'call_log:view\' permission.
         * @summary Get Transcript Turns
         * @param {string} transcriptId 
         * @param {TurnType | null} [turnType] Filter by turn type
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet_4: async (transcriptId: string, turnType?: TurnType | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transcriptId' is not null or undefined
            assertParamExists('getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet_4', 'transcriptId', transcriptId)
            const localVarPath = `/api/v1/transcripts/{transcript_id}/turns`
                .replace(`{${"transcript_id"}}`, encodeURIComponent(String(transcriptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (turnType !== undefined) {
                localVarQueryParameter['turn_type'] = turnType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all transcripts in the current user\'s organization. Requires \'call_log:view\' permission.
         * @summary List Transcripts
         * @param {string | null} [agentId] Filter by specific agent
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTranscriptsApiV1TranscriptsGet: async (agentId?: string | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/transcripts/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all transcripts in the current user\'s organization. Requires \'call_log:view\' permission.
         * @summary List Transcripts
         * @param {string | null} [agentId] Filter by specific agent
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTranscriptsApiV1TranscriptsGet_5: async (agentId?: string | null, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/transcripts/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search transcripts using full-text search on conversation content. Uses German language processing for optimal search results. Requires \'call_log:view\' permission.
         * @summary Search Transcripts
         * @param {string} q Search query (German full-text search)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [agentId] Filter by specific agent
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTranscriptsApiV1TranscriptsSearchGet: async (q: string, limit?: number, offset?: number, agentId?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('searchTranscriptsApiV1TranscriptsSearchGet', 'q', q)
            const localVarPath = `/api/v1/transcripts/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search transcripts using full-text search on conversation content. Uses German language processing for optimal search results. Requires \'call_log:view\' permission.
         * @summary Search Transcripts
         * @param {string} q Search query (German full-text search)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [agentId] Filter by specific agent
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTranscriptsApiV1TranscriptsSearchGet_6: async (q: string, limit?: number, offset?: number, agentId?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('searchTranscriptsApiV1TranscriptsSearchGet_6', 'q', q)
            const localVarPath = `/api/v1/transcripts/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search turns within a specific transcript. Uses German full-text search on turn content. Requires \'call_log:view\' permission.
         * @summary Search Turns In Transcript
         * @param {string} transcriptId 
         * @param {string} q Search query within transcript
         * @param {number} [limit] Maximum number of results
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet: async (transcriptId: string, q: string, limit?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transcriptId' is not null or undefined
            assertParamExists('searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet', 'transcriptId', transcriptId)
            // verify required parameter 'q' is not null or undefined
            assertParamExists('searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet', 'q', q)
            const localVarPath = `/api/v1/transcripts/{transcript_id}/turns/search`
                .replace(`{${"transcript_id"}}`, encodeURIComponent(String(transcriptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search turns within a specific transcript. Uses German full-text search on turn content. Requires \'call_log:view\' permission.
         * @summary Search Turns In Transcript
         * @param {string} transcriptId 
         * @param {string} q Search query within transcript
         * @param {number} [limit] Maximum number of results
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet_7: async (transcriptId: string, q: string, limit?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transcriptId' is not null or undefined
            assertParamExists('searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet_7', 'transcriptId', transcriptId)
            // verify required parameter 'q' is not null or undefined
            assertParamExists('searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet_7', 'q', q)
            const localVarPath = `/api/v1/transcripts/{transcript_id}/turns/search`
                .replace(`{${"transcript_id"}}`, encodeURIComponent(String(transcriptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TranscriptsApi - functional programming interface
 * @export
 */
export const TranscriptsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TranscriptsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a specific transcript with all turns. Requires \'call_log:view\' permission.
         * @summary Get Transcript
         * @param {string} transcriptId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranscriptApiV1TranscriptsTranscriptIdGet(transcriptId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationTranscriptResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranscriptApiV1TranscriptsTranscriptIdGet(transcriptId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptsApi.getTranscriptApiV1TranscriptsTranscriptIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific transcript with all turns. Requires \'call_log:view\' permission.
         * @summary Get Transcript
         * @param {string} transcriptId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranscriptApiV1TranscriptsTranscriptIdGet_1(transcriptId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationTranscriptResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranscriptApiV1TranscriptsTranscriptIdGet_1(transcriptId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptsApi.getTranscriptApiV1TranscriptsTranscriptIdGet_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get transcript by call log ID with all turns. Returns 404 if no transcript exists for the call log. Requires \'call_log:view\' permission.
         * @summary Get Transcript By Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationTranscriptResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptsApi.getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get transcript by call log ID with all turns. Returns 404 if no transcript exists for the call log. Requires \'call_log:view\' permission.
         * @summary Get Transcript By Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet_2(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationTranscriptResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet_2(callLogId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptsApi.getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all function calls for a specific transcript. Requires \'call_log:view\' permission.
         * @summary Get Transcript Function Calls
         * @param {string} transcriptId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet(transcriptId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConversationTurnDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet(transcriptId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptsApi.getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all function calls for a specific transcript. Requires \'call_log:view\' permission.
         * @summary Get Transcript Function Calls
         * @param {string} transcriptId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet_3(transcriptId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConversationTurnDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet_3(transcriptId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptsApi.getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get turns for a specific transcript with optional filtering. Can filter by turn type (user_speech, agent_speech, function_call, event). Requires \'call_log:view\' permission.
         * @summary Get Transcript Turns
         * @param {string} transcriptId 
         * @param {TurnType | null} [turnType] Filter by turn type
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet(transcriptId: string, turnType?: TurnType | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageConversationTurnDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet(transcriptId, turnType, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptsApi.getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get turns for a specific transcript with optional filtering. Can filter by turn type (user_speech, agent_speech, function_call, event). Requires \'call_log:view\' permission.
         * @summary Get Transcript Turns
         * @param {string} transcriptId 
         * @param {TurnType | null} [turnType] Filter by turn type
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet_4(transcriptId: string, turnType?: TurnType | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageConversationTurnDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet_4(transcriptId, turnType, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptsApi.getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all transcripts in the current user\'s organization. Requires \'call_log:view\' permission.
         * @summary List Transcripts
         * @param {string | null} [agentId] Filter by specific agent
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTranscriptsApiV1TranscriptsGet(agentId?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageConversationTranscriptListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTranscriptsApiV1TranscriptsGet(agentId, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptsApi.listTranscriptsApiV1TranscriptsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all transcripts in the current user\'s organization. Requires \'call_log:view\' permission.
         * @summary List Transcripts
         * @param {string | null} [agentId] Filter by specific agent
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTranscriptsApiV1TranscriptsGet_5(agentId?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageConversationTranscriptListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTranscriptsApiV1TranscriptsGet_5(agentId, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptsApi.listTranscriptsApiV1TranscriptsGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search transcripts using full-text search on conversation content. Uses German language processing for optimal search results. Requires \'call_log:view\' permission.
         * @summary Search Transcripts
         * @param {string} q Search query (German full-text search)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [agentId] Filter by specific agent
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTranscriptsApiV1TranscriptsSearchGet(q: string, limit?: number, offset?: number, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TranscriptSearchResultDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTranscriptsApiV1TranscriptsSearchGet(q, limit, offset, agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptsApi.searchTranscriptsApiV1TranscriptsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search transcripts using full-text search on conversation content. Uses German language processing for optimal search results. Requires \'call_log:view\' permission.
         * @summary Search Transcripts
         * @param {string} q Search query (German full-text search)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [agentId] Filter by specific agent
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTranscriptsApiV1TranscriptsSearchGet_6(q: string, limit?: number, offset?: number, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TranscriptSearchResultDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTranscriptsApiV1TranscriptsSearchGet_6(q, limit, offset, agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptsApi.searchTranscriptsApiV1TranscriptsSearchGet_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search turns within a specific transcript. Uses German full-text search on turn content. Requires \'call_log:view\' permission.
         * @summary Search Turns In Transcript
         * @param {string} transcriptId 
         * @param {string} q Search query within transcript
         * @param {number} [limit] Maximum number of results
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet(transcriptId: string, q: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConversationTurnDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet(transcriptId, q, limit, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptsApi.searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search turns within a specific transcript. Uses German full-text search on turn content. Requires \'call_log:view\' permission.
         * @summary Search Turns In Transcript
         * @param {string} transcriptId 
         * @param {string} q Search query within transcript
         * @param {number} [limit] Maximum number of results
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet_7(transcriptId: string, q: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConversationTurnDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet_7(transcriptId, q, limit, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranscriptsApi.searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TranscriptsApi - factory interface
 * @export
 */
export const TranscriptsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TranscriptsApiFp(configuration)
    return {
        /**
         * Get a specific transcript with all turns. Requires \'call_log:view\' permission.
         * @summary Get Transcript
         * @param {string} transcriptId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptApiV1TranscriptsTranscriptIdGet(transcriptId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ConversationTranscriptResponseDTO> {
            return localVarFp.getTranscriptApiV1TranscriptsTranscriptIdGet(transcriptId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific transcript with all turns. Requires \'call_log:view\' permission.
         * @summary Get Transcript
         * @param {string} transcriptId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptApiV1TranscriptsTranscriptIdGet_1(transcriptId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ConversationTranscriptResponseDTO> {
            return localVarFp.getTranscriptApiV1TranscriptsTranscriptIdGet_1(transcriptId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get transcript by call log ID with all turns. Returns 404 if no transcript exists for the call log. Requires \'call_log:view\' permission.
         * @summary Get Transcript By Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ConversationTranscriptResponseDTO> {
            return localVarFp.getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get transcript by call log ID with all turns. Returns 404 if no transcript exists for the call log. Requires \'call_log:view\' permission.
         * @summary Get Transcript By Call Log
         * @param {string} callLogId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet_2(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ConversationTranscriptResponseDTO> {
            return localVarFp.getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet_2(callLogId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all function calls for a specific transcript. Requires \'call_log:view\' permission.
         * @summary Get Transcript Function Calls
         * @param {string} transcriptId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet(transcriptId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ConversationTurnDTO>> {
            return localVarFp.getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet(transcriptId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all function calls for a specific transcript. Requires \'call_log:view\' permission.
         * @summary Get Transcript Function Calls
         * @param {string} transcriptId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet_3(transcriptId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ConversationTurnDTO>> {
            return localVarFp.getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet_3(transcriptId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get turns for a specific transcript with optional filtering. Can filter by turn type (user_speech, agent_speech, function_call, event). Requires \'call_log:view\' permission.
         * @summary Get Transcript Turns
         * @param {string} transcriptId 
         * @param {TurnType | null} [turnType] Filter by turn type
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet(transcriptId: string, turnType?: TurnType | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageConversationTurnDTO> {
            return localVarFp.getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet(transcriptId, turnType, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get turns for a specific transcript with optional filtering. Can filter by turn type (user_speech, agent_speech, function_call, event). Requires \'call_log:view\' permission.
         * @summary Get Transcript Turns
         * @param {string} transcriptId 
         * @param {TurnType | null} [turnType] Filter by turn type
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet_4(transcriptId: string, turnType?: TurnType | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageConversationTurnDTO> {
            return localVarFp.getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet_4(transcriptId, turnType, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all transcripts in the current user\'s organization. Requires \'call_log:view\' permission.
         * @summary List Transcripts
         * @param {string | null} [agentId] Filter by specific agent
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTranscriptsApiV1TranscriptsGet(agentId?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageConversationTranscriptListDTO> {
            return localVarFp.listTranscriptsApiV1TranscriptsGet(agentId, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all transcripts in the current user\'s organization. Requires \'call_log:view\' permission.
         * @summary List Transcripts
         * @param {string | null} [agentId] Filter by specific agent
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTranscriptsApiV1TranscriptsGet_5(agentId?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageConversationTranscriptListDTO> {
            return localVarFp.listTranscriptsApiV1TranscriptsGet_5(agentId, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search transcripts using full-text search on conversation content. Uses German language processing for optimal search results. Requires \'call_log:view\' permission.
         * @summary Search Transcripts
         * @param {string} q Search query (German full-text search)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [agentId] Filter by specific agent
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTranscriptsApiV1TranscriptsSearchGet(q: string, limit?: number, offset?: number, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TranscriptSearchResultDTO>> {
            return localVarFp.searchTranscriptsApiV1TranscriptsSearchGet(q, limit, offset, agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search transcripts using full-text search on conversation content. Uses German language processing for optimal search results. Requires \'call_log:view\' permission.
         * @summary Search Transcripts
         * @param {string} q Search query (German full-text search)
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {string | null} [agentId] Filter by specific agent
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTranscriptsApiV1TranscriptsSearchGet_6(q: string, limit?: number, offset?: number, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TranscriptSearchResultDTO>> {
            return localVarFp.searchTranscriptsApiV1TranscriptsSearchGet_6(q, limit, offset, agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search turns within a specific transcript. Uses German full-text search on turn content. Requires \'call_log:view\' permission.
         * @summary Search Turns In Transcript
         * @param {string} transcriptId 
         * @param {string} q Search query within transcript
         * @param {number} [limit] Maximum number of results
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet(transcriptId: string, q: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ConversationTurnDTO>> {
            return localVarFp.searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet(transcriptId, q, limit, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search turns within a specific transcript. Uses German full-text search on turn content. Requires \'call_log:view\' permission.
         * @summary Search Turns In Transcript
         * @param {string} transcriptId 
         * @param {string} q Search query within transcript
         * @param {number} [limit] Maximum number of results
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet_7(transcriptId: string, q: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ConversationTurnDTO>> {
            return localVarFp.searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet_7(transcriptId, q, limit, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TranscriptsApi - object-oriented interface
 * @export
 * @class TranscriptsApi
 * @extends {BaseAPI}
 */
export class TranscriptsApi extends BaseAPI {
    /**
     * Get a specific transcript with all turns. Requires \'call_log:view\' permission.
     * @summary Get Transcript
     * @param {string} transcriptId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptsApi
     */
    public getTranscriptApiV1TranscriptsTranscriptIdGet(transcriptId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return TranscriptsApiFp(this.configuration).getTranscriptApiV1TranscriptsTranscriptIdGet(transcriptId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific transcript with all turns. Requires \'call_log:view\' permission.
     * @summary Get Transcript
     * @param {string} transcriptId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptsApi
     */
    public getTranscriptApiV1TranscriptsTranscriptIdGet_1(transcriptId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return TranscriptsApiFp(this.configuration).getTranscriptApiV1TranscriptsTranscriptIdGet_1(transcriptId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get transcript by call log ID with all turns. Returns 404 if no transcript exists for the call log. Requires \'call_log:view\' permission.
     * @summary Get Transcript By Call Log
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptsApi
     */
    public getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return TranscriptsApiFp(this.configuration).getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get transcript by call log ID with all turns. Returns 404 if no transcript exists for the call log. Requires \'call_log:view\' permission.
     * @summary Get Transcript By Call Log
     * @param {string} callLogId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptsApi
     */
    public getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet_2(callLogId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return TranscriptsApiFp(this.configuration).getTranscriptByCallLogApiV1TranscriptsByCallLogCallLogIdGet_2(callLogId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all function calls for a specific transcript. Requires \'call_log:view\' permission.
     * @summary Get Transcript Function Calls
     * @param {string} transcriptId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptsApi
     */
    public getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet(transcriptId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return TranscriptsApiFp(this.configuration).getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet(transcriptId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all function calls for a specific transcript. Requires \'call_log:view\' permission.
     * @summary Get Transcript Function Calls
     * @param {string} transcriptId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptsApi
     */
    public getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet_3(transcriptId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return TranscriptsApiFp(this.configuration).getTranscriptFunctionCallsApiV1TranscriptsTranscriptIdFunctionCallsGet_3(transcriptId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get turns for a specific transcript with optional filtering. Can filter by turn type (user_speech, agent_speech, function_call, event). Requires \'call_log:view\' permission.
     * @summary Get Transcript Turns
     * @param {string} transcriptId 
     * @param {TurnType | null} [turnType] Filter by turn type
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptsApi
     */
    public getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet(transcriptId: string, turnType?: TurnType | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return TranscriptsApiFp(this.configuration).getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet(transcriptId, turnType, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get turns for a specific transcript with optional filtering. Can filter by turn type (user_speech, agent_speech, function_call, event). Requires \'call_log:view\' permission.
     * @summary Get Transcript Turns
     * @param {string} transcriptId 
     * @param {TurnType | null} [turnType] Filter by turn type
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptsApi
     */
    public getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet_4(transcriptId: string, turnType?: TurnType | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return TranscriptsApiFp(this.configuration).getTranscriptTurnsApiV1TranscriptsTranscriptIdTurnsGet_4(transcriptId, turnType, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all transcripts in the current user\'s organization. Requires \'call_log:view\' permission.
     * @summary List Transcripts
     * @param {string | null} [agentId] Filter by specific agent
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptsApi
     */
    public listTranscriptsApiV1TranscriptsGet(agentId?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return TranscriptsApiFp(this.configuration).listTranscriptsApiV1TranscriptsGet(agentId, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all transcripts in the current user\'s organization. Requires \'call_log:view\' permission.
     * @summary List Transcripts
     * @param {string | null} [agentId] Filter by specific agent
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptsApi
     */
    public listTranscriptsApiV1TranscriptsGet_5(agentId?: string | null, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return TranscriptsApiFp(this.configuration).listTranscriptsApiV1TranscriptsGet_5(agentId, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search transcripts using full-text search on conversation content. Uses German language processing for optimal search results. Requires \'call_log:view\' permission.
     * @summary Search Transcripts
     * @param {string} q Search query (German full-text search)
     * @param {number} [limit] Maximum number of results
     * @param {number} [offset] Number of results to skip
     * @param {string | null} [agentId] Filter by specific agent
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptsApi
     */
    public searchTranscriptsApiV1TranscriptsSearchGet(q: string, limit?: number, offset?: number, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return TranscriptsApiFp(this.configuration).searchTranscriptsApiV1TranscriptsSearchGet(q, limit, offset, agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search transcripts using full-text search on conversation content. Uses German language processing for optimal search results. Requires \'call_log:view\' permission.
     * @summary Search Transcripts
     * @param {string} q Search query (German full-text search)
     * @param {number} [limit] Maximum number of results
     * @param {number} [offset] Number of results to skip
     * @param {string | null} [agentId] Filter by specific agent
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptsApi
     */
    public searchTranscriptsApiV1TranscriptsSearchGet_6(q: string, limit?: number, offset?: number, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return TranscriptsApiFp(this.configuration).searchTranscriptsApiV1TranscriptsSearchGet_6(q, limit, offset, agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search turns within a specific transcript. Uses German full-text search on turn content. Requires \'call_log:view\' permission.
     * @summary Search Turns In Transcript
     * @param {string} transcriptId 
     * @param {string} q Search query within transcript
     * @param {number} [limit] Maximum number of results
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptsApi
     */
    public searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet(transcriptId: string, q: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return TranscriptsApiFp(this.configuration).searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet(transcriptId, q, limit, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search turns within a specific transcript. Uses German full-text search on turn content. Requires \'call_log:view\' permission.
     * @summary Search Turns In Transcript
     * @param {string} transcriptId 
     * @param {string} q Search query within transcript
     * @param {number} [limit] Maximum number of results
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranscriptsApi
     */
    public searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet_7(transcriptId: string, q: string, limit?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return TranscriptsApiFp(this.configuration).searchTurnsInTranscriptApiV1TranscriptsTranscriptIdTurnsSearchGet_7(transcriptId, q, limit, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

